"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Trust = function Trust(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 17 19",
    width: "17",
    height: "19"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.00002 3.3601V9.02177C1.00004 10.8113 1.54234 12.5589 2.55543 14.034C3.56852 15.5092 5.00485 16.6428 6.67508 17.2853L7.44916 17.5827C7.96464 17.781 8.53536 17.781 9.05084 17.5827L9.82492 17.2853C11.4951 16.6428 12.9315 15.5092 13.9446 14.034C14.9577 12.5589 15.5 10.8113 15.5 9.02177V3.3601C15.5014 3.14705 15.4412 2.93812 15.3267 2.75845C15.2122 2.57878 15.0483 2.43602 14.8545 2.34733C12.7724 1.43851 10.5218 0.979621 8.25 1.00069C5.97823 0.979621 3.72762 1.43851 1.64546 2.34733C1.45174 2.43602 1.28776 2.57878 1.17326 2.75845C1.05876 2.93812 0.9986 3.14705 1.00002 3.3601V3.3601Z",
    stroke: fill,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.1172 8.80832C12.0104 9.54882 11.6929 10.243 11.2028 10.8082C10.7126 11.3735 10.0703 11.786 9.35243 11.9966C8.63452 12.2072 7.8712 12.2071 7.15335 11.9963C6.4355 11.7854 5.79336 11.3728 5.30336 10.8074C4.81336 10.242 4.49615 9.54771 4.38949 8.80718C4.28282 8.06666 4.3912 7.31107 4.70172 6.63039C5.01224 5.9497 5.51182 5.37258 6.14099 4.96773C6.77016 4.56288 7.50241 4.34735 8.25058 4.3468",
    stroke: fill,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.1533 5.32251L8.59449 8.88132C8.50291 8.97268 8.37883 9.02398 8.24947 9.02398C8.12011 9.02398 7.99603 8.97268 7.90444 8.88132L6.78906 7.76222",
    stroke: fill,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }));
};
Trust.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Trust.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Trust;